import React, { useState } from 'react';
import '../styling/ContactPage.css';
import { db } from '../firebaseConfig';
import { collection, addDoc } from "firebase/firestore";

function ContactPage() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async(e) => {
    e.preventDefault();
   
    try {
      await addDoc(collection(db, "newsletter"), {
        email: email,
        subscribedAt: new Date().toISOString()
      });
      setSubscribed(true);
      setError(null);
    } catch (err) {
      console.error("Error adding document: ", err);
      setError("Subscription failed. Please try again.");
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-container container">
        <h3>Subscribe to our Newsletter!</h3>
        <p className="subscribe-description">
          Stay up-to-date with exclusive updates on our games, behind-the-scenes insights, and early access to upcoming releases.
        </p>
        {subscribed ? (
          <p className="subscribe-thankyou">Thank you for subscribing!</p>
        ) : (
          <form onSubmit={handleSubmit} className="subscribe-form container">
            <div className="row">
              <div className="col-9">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="form-control"
                />
              </div>
              <div className="col-3">
                <button type="submit" className="btn submit">
                  <strong>Subscribe</strong>
                </button>
              </div>
            </div>
            {error && <p className="error">{error}</p>}
          </form>
        )}
      </div>
    </section>
  );
}

export default ContactPage;